import React from 'react'
import './Experience.css'
import Section from '../section/Section'
import ExperienceCard from '../experienceCard/ExperienceCard'
import experienceData from '../../data/experience.json'
import { useScrollReveal } from '../../hooks/useScrollReveal'

const Experience = () => {
  const listRef = useScrollReveal({ y: 25, stagger: 0.12 })
  const ctaRef = useScrollReveal({ y: 20 })

  return (
    <Section title="Experiências" stage="experiencias">
      <div className="experience-content">
        <ul className="experience-list" ref={listRef}>
          {experienceData.experience
            .slice()
            .reverse()
            .map((exp) => (
              <li key={`experience-${exp.company}`} data-reveal-item>
                <ExperienceCard experience={exp} />
              </li>
            ))}
        </ul>
        <div ref={ctaRef} style={{ display: 'flex', justifyContent: 'center' }}>
          <p style={{ textAlign: 'center' }}>
            Experiências mais detalhadas podem ser encontradas no meu{' '}
            <a
              href="https://www.linkedin.com/in/jardersilva/"
              target="_blank"
              rel="noopener noreferrer"
              style={{
                textDecoration: 'none',
                color: '#0077B5',
                cursor: 'pointer',
              }}
            >
              LinkedIn
            </a>
            .
          </p>
        </div>
      </div>
    </Section>
  )
}

export default Experience
